import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { createQueryClient } from './services/queries';
import App from './App';
import { UnsavedChangesGuard } from './components/UnsavedChanges';
import { followTheme } from './theme/themeStore';
import { localeUses24Hour, setClockStyle } from '@cerebro-diem/core';
import './index.css';

// index.html already put the theme on <html>; from here it follows the device and other tabs.
followTheme();
// Times read the way this browser's locale does, 12- or 24-hour (CER-232).
setClockStyle(localeUses24Hour());

const queryClient = createQueryClient();

// A data router, so an editor with unsaved changes can hold a navigation
// (useBlocker needs one); App keeps its own <Routes> under this one route.
const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <UnsavedChangesGuard>
        <App />
      </UnsavedChangesGuard>
    ),
  },
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>
);
